import { inject, Injectable } from '@angular/core'

import { HttpService } from '@app/services/http.service'

export interface InteractionContextResponse {
  has_pending_received_photo_requests: boolean
  has_pending_profile_views: boolean
  has_pending_admirers: boolean
  favorited_target_ids: number[]
  messages_dot_ids: number[]
  locked_approved_created_photo_requests: boolean
  unlocked_approved_created_photo_requests: boolean
}

@Injectable({
  providedIn: 'root',
})
export class InteractionContextService {
  private readonly httpService = inject(HttpService)

  load() {
    return this.httpService.get<InteractionContextResponse>('interactions2')
  }
}
